import React from "react";
import { Link } from "react-router-dom";
import logo1 from "../img/Mlogo1.webp";
import logo2 from "../img/Mlogo2.png";
import logo3 from "../img/Mlogo3.webp";
import logo4 from "../img/Mlogo4.webp";
import logo5 from "../img/Mlogo5.jpg";
import logo6 from "../img/onlineCake.png";
import logo7 from "../img/Mlogo6.jpg";
import logo8 from "../img/Mlogo8.jpg";
import logo9 from "../img/Mlogo9.jpg";
import logo10 from "../img/Mlogo10.jpg";

export default function Ourpartnerss() {
  const logos = [
    { src: logo1, link: "https://semya.in/" },
    { src: logo2, link: "https://www.queenley.me/" },
    { src: logo3, link: "https://theburgercompany.co/" },
    { src: logo4, link: "https://paanaroma.com/" },
    { src: logo5, link: "https://www.globaldesi.in" },
    { src: logo6, link: "https://www.onlinecakencr.com/" },
    { src: logo7, link: "https://sunasa.in/" },
    { src: logo8, link: "https://vlccpersonalcare.com/" },
    { src: logo9, link: "https://www.rangriti.com/" },
    { src: logo10, link: "https://basicslife.com/" },
  ];

  return (
    <div className="our-partners my-5">
      <div
        className="d-flex justify-content-between align-items-center flex-nowrap"
        style={{
          overflowX: "auto",
          gap: "2rem",
          padding: "0 1rem",
        }}
      >
        {logos.map((logo, index) => (
          <Link key={index} to={logo.link} className="flex-shrink-0">
            <img
              src={logo.src}
              alt={`Partner ${index + 1}`}
              className="img-fluid"
              style={{
                maxHeight: "60px", // default
                width: "auto",
              }}
            />
          </Link>
        ))}
      </div>

      {/* Responsive scaling */}
      <style>
        {`
          @media (max-width: 992px) {  /* tablets */
            .our-partners img {
              max-height: 50px !important;
            }
          }
          @media (max-width: 768px) {  /* mobiles */
            .our-partners img {
              max-height: 40px !important;
            }
          }
          @media (max-width: 576px) {  /* small mobiles */
            .our-partners {
            margin-top:-2rem;
            }
            .our-partners img {
              max-height: 50px !important;
            }
          }
        `}
      </style>
    </div>
  );
}
